import Vue from 'vue'
import firebase from 'firebase'
import Router from 'vue-router'
import Login from './views/Login.vue'
import Select from './views/Select.vue'
import Table from './views/Table.vue'
import Standalone from './views/Standalone.vue'

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/',
      name: 'login',
      component: Login
    },
    {
      path: '/select',
      name: 'select',
      component: Select,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/standalone',
      name: 'standalone',
      component: Standalone,
      meta: {
        requiresAuth: false
      }
    },
    {
      path: '/table',
      name: 'table',
      component: Table,
      meta: {
        requiresAuth: true
      }
    }
  ]
})

router.beforeEach((to, from, next) => {
  const currentUser = firebase.auth().currentUser
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth)
  if (requiresAuth && !currentUser) next('/')
  else if (!requiresAuth && currentUser) next('/about')
  else next()
})

export default router
